import { type Command } from '@/components/tiptap/sharedExtensions/slash-command/types';
import { Button } from '@heidi/design-system/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@heidi/design-system/dropdown-menu';
import { TypographyP2 } from '@heidi/design-system/typography';
import { type Editor } from '@tiptap/react';
import { ChevronDown, Plus } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

interface InsertMenuProps {
  editor: Editor;
  getCommands: (editor: Editor) => Command[];
}

export function InsertMenu({ editor, getCommands }: InsertMenuProps) {
  const commands = getCommands(editor);

  if (commands.length === 0) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="xs"
          onMouseDown={(event) => event.preventDefault()}
          data-testid="insert-menu-button"
        >
          <Plus />
          <TypographyP2>
            <FormattedMessage defaultMessage="Insert" id="freMIMRjYc" />
          </TypographyP2>
          <ChevronDown />
        </Button>
      </DropdownMenuTrigger>
      {/* Commands focus the editor themselves; don't return focus to the trigger on close. */}
      <DropdownMenuContent
        align="start"
        onCloseAutoFocus={(event) => event.preventDefault()}
      >
        {commands.map((command) => (
          <DropdownMenuItem
            key={command.name}
            data-testid={`insert-menu-item-${command.name}`}
            onMouseDown={(event) => event.preventDefault()}
            onSelect={() => command.action(editor)}
          >
            {command.icon && <command.icon />}
            {command.content}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
